import { UnitProgramTasksPage } from '@apps-common/apps/portal/pages/units/pages/program-tasks/Index'

export const UnitProgramTasks = () => <UnitProgramTasksPage />
